export default "__VITE_ASSET__BEpJKkl0__"